export const css = {
    root: 'vwpsun2f',
    atiContainer: '_7p9njr--',
    leftPanel: '_9NlWm9fh',
    rightPanel: 'ySQd5FST',
    messages: 'xWqHcD1J',
    messageItem: 'YpzdKNl3',
    messageMetadata: 'uD-T00Jk',
    messageAuthor: 'BS-PKb90',
    messagePostDate: 'wiHUs8P8',
    messageText: 'UMV8EWq-',
    messageReply: 'wiRLaLSW',
    ' _key': 'ask-the-instructor/ati'
};
export default css;
